export default {
  settings: {
    title: "Setings",
    form: {
      fastRun: "Fast run",
      fastRunOptions: {
        classic: "Classic",
        basic: "Basic",
        user: "Custom"
      }
    },
    notify: {
      title: "Fast run",
      message: "Settings saved successfully"
    }
  }
};
